import { Grid, Spinner, Text } from "@radix-ui/themes";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

import { isNil } from "../../../utils/fp";
import { useAppDispatch } from "../../../utils/hooks";
import { useFoldersAndTicketsMutation } from "../../../utils/queries/projects";
import { mergePunttProjectState } from "../../../utils/slices/punttProjects";
import { ticketsRoute } from "../route";

interface InfiniteScrollTriggerProps {
  lastItemIndex?: string;
  hasMore: boolean;
}

export function InfiniteScrollTrigger({
  lastItemIndex,
  hasMore,
}: InfiniteScrollTriggerProps) {
  const { ref, inView } = useInView({
    threshold: 0,
    rootMargin: "200px 0px",
  });
  const { folderId, pageSize, ticketTitle, participants } =
    ticketsRoute.useSearch();
  const dispatch = useAppDispatch();
  const foldersAndTicketsMutation = useFoldersAndTicketsMutation(folderId);

  useEffect(() => {
    if (inView && hasMore && !isNil(lastItemIndex)) {
      dispatch(mergePunttProjectState({ isLoadingMore: true }));
      foldersAndTicketsMutation.mutate({
        folderId,
        pageSize,
        ticketTitle,
        participants,
        // send lastItemDate timestamp unix,_id
        searchAfter: lastItemIndex,
      });
    }
  }, [inView, hasMore, lastItemIndex]);

  if (!hasMore) return null;

  return (
    <Grid ref={ref} py="4" gap="3" maxWidth="max-content" mx="auto">
      <Spinner mx="auto" />

      <Text>Loading More</Text>
    </Grid>
  );
}
